module.exports = __webpack_public_path__ + "static/media/shadow-attack-0.d36c9ba1.png";